
/* tslint:disable:quotemark */
import { defineMessages } from "react-intl";


const MESSAGES = defineMessages({
  cutoutPartDetailName: {
    id: "CutoutPartDetail.name",
    defaultMessage: "Name",
  }, 
  cutoutPartDetailDimensions: {
    id: "CutoutPartDetail.dimensions",
    defaultMessage: "Dimensions",
  }, 
  cutoutPartDetailType: {
    id: "CutoutPartDetail.type",
    defaultMessage: "Type",
  }, 
  cutoutPartDetailArticle: {
    id: "CutoutPartDetail.article",
    defaultMessage: "Article Number",
  }, 
});

export default MESSAGES;